export default {
  appTitle: 'LoanKnow',
  apiUrl: 'https://api.go.uff.pro/api',
  appEnv: 'production',
  useMockServices: false,
  supabaseUrl: 'https://pvzqgboffydqeqzeiysx.supabase.co',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2enFnYm9mZnlkcWVxemVpeXN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE2MjU4NjcsImV4cCI6MjA4NzIwMTg2N30.gVgxdlVF3lnvoL8BSPOngx15fwBibiRx9VLtuL3z12I',
};
